import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';


import Contact from '../components/Contact';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import '../App.css';
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';



const HomePage = () => {
  const [showWhatsAppTooltip, setShowWhatsAppTooltip] = useState(false);

  // WhatsApp configuration
  const whatsappNumber = '+917600236927';
  const whatsappMessage = 'Hi! I would like to discuss a project with DEPLOY-X.';
  const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  // Auto-show tooltip after 3 seconds
  React.useEffect(() => {
    const tooltipTimer = setTimeout(() => {
      setShowWhatsAppTooltip(true);
      // Auto-hide after 5 seconds
      setTimeout(() => setShowWhatsAppTooltip(false), 5000);
    }, 3000);
    return () => clearTimeout(tooltipTimer);
  }, []);
  return (
    <>
      <SEO
        title="DEPLOY-X – AI-Powered Digital Solutions | Web & Mobile Development"
        description="Transform your business with DEPLOY-X's cutting-edge AI solutions, web development, mobile apps, and cloud services. Expert digital transformation partner in India."
        pathname="/"
        keywords={['AI solutions India', 'web development', 'mobile app development', 'digital transformation', 'cloud services']}
      />
      <div className="page-wrapper">
        <div className="App">
          <main>
            <Hero />
            <Services />
            <About />
            <Contact />
            <Footer />
          </main>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <div className="whatsapp-float-container">
        <AnimatePresence>
          {showWhatsAppTooltip && (
            <motion.div
              className="whatsapp-tooltip"
              initial={{ opacity: 0, x: 20, scale: 0.8 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: 20, scale: 0.8 }}
              transition={{ duration: 0.3 }}
            >
              <button className="tooltip-close" onClick={() => setShowWhatsAppTooltip(false)}>
                <FaTimes />
              </button>
              <p className="tooltip-text">
                <strong>Need Help?</strong><br />
                Chat with us on WhatsApp!
              </p>
            </motion.div>
          )}
        </AnimatePresence>

        <motion.a
          href={whatsappURL}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 260, damping: 20, delay: 1 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onMouseEnter={() => setShowWhatsAppTooltip(true)}
          onMouseLeave={() => setShowWhatsAppTooltip(false)}
        >
          <FaWhatsapp className="whatsapp-icon" />
          <span className="pulse-ring"></span>
          <span className="pulse-ring pulse-ring-delay"></span>
        </motion.a>
      </div>
    </>
  );
};

export default HomePage;
